module.exports = __webpack_public_path__ + "static/media/ticket-center.d6f94487.png";